import styled from 'styled-components';
import { margin, padding, pxToRem } from '../../styles/mixins';

export const Container = styled.div`
  ${margin(48, 'auto', 0)};
  max-width: 1295px;
  width: 100%;
  
	@media screen and (max-width: 1365px) {
		padding: 0 10px;
	}
`
export const TitleError = styled.h2`
  ${pxToRem(56)};
  font-weight: 400;
  ${margin(0, 0, 18, 0)};
  color: var(--gray-900);
`
export const TextSugestions = styled.p`
  ${pxToRem(16)};
  ${margin(34, 0, 20, 0)};
  font-weight: 400;
  color: var(--gray-900);
`
export const TextTop = styled.h3`
  ${pxToRem(16)};
  font-weight: 700;
  color: var(--ins-blue);
  margin-bottom: 16px;
`
export const Paragraph = styled.p`
  color: var(--gray-500);
  ${pxToRem(16)};
  ${margin(0, 0, 16, 0)};
`
export const ParagraphError = styled.p`
  ${pxToRem(20)};
  ${margin(34, 0, 20, 0)};
  font-weight: 400;
  color: var(--black);
  white-space: pre-wrap;
`
export const ListErrors = styled.ul`
  list-style: disc;
  ${padding(0, 0, 0, 20)};
  ${margin(0, 0, 50, 0)};

  li {
    margin-bottom: 10px;
  }
`
export const ButtonErrors = styled.button`
  width: 100%;
  height: 42px;
  max-width: 208px;
  background-color: var(--ins-blue);
  border: none;
  border-radius: 8px;
  color: var(--white);
  ${pxToRem(16)};
  font-weight: 700;
  transition: .2s;

	&:hover {
		background-color:#583eff;
    color: var(--white);
	}
`